import * as types from 'actions/app/types';
import { INIT_UI_LANGUAGE } from 'constants/languages';

const initialState = {
  mouseControlsEnabled: false,
  onUserDataInit: true,
  authSteps: 0,
  UILanguage: INIT_UI_LANGUAGE,
};

const AUTH_PAGES_REG_EXP = /authorization/;

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ENABLE_MOUSE_CONTROLS:
      const { mouseControlsEnabled } = action.payload;
      return { ...state, mouseControlsEnabled };
    case types.INIT_USER_DATA:
      return { ...state, onUserDataInit: true };
    case types.INIT_USER_DATA_SUCCESS:
    case types.INIT_USER_DATA_ERROR:
      return { ...state, onUserDataInit: false };
    case types.CHANGE_UI_LANGUAGE: {
      return { ...state, UILanguage: action.payload };
    }
    case types.RESET_AUTH_STEPS:
      return { ...state, authSteps: 0 };
    /*
     * Это нужно для того, чтобы правильно вернуть пользователя
     * на страницу с которой началась авторизация.
     *
     * Вариантов сколько страниц авторизации может пройти пользователь
     * слишком много, чтобы учесть их в переменных
     * (на 13.05.2020 больше 6-ми вариантов)
     * Поэтому нужно слушать роутер напрямую и считать пройденные
     * страницы авторизации
     * Самый универсальный способ это делать - слушать роутер,
     * проверять как измелилась локация и сохранять значение
     */
    case types.LOCATION_CHANGE:
      const { pathname: prevPathname } = action.payload.prevLocation;
      const { pathname } = action.payload.location;
      const { action: actionName } = action.payload;
      if (AUTH_PAGES_REG_EXP.test(pathname)) {
        let value = 0;
        if (actionName === 'PUSH') value = 1;
        // Count ONLY auth pages
        if (actionName === 'POP' && AUTH_PAGES_REG_EXP.test(prevPathname)) value = -1;
        const authSteps = state.authSteps + value;
        // Можно обновить страницу на каком-то из шагов авторизации и получить отрицательные шаги
        return { ...state, authSteps: authSteps > 0 ? authSteps : 0 };
      } else if (state.authSteps > 0) {
        // Reset auth step if user left auth flow
        return { ...state, authSteps: 0 };
      }
      return state;
    default:
      return state;
  }
};
